/* eslint-disable */
import React from 'react';
import { Typography, Paper, Box, List, ListItem, ListItemText, Divider } from '@mui/material';
import { useLocation } from 'react-router-dom';

const ThankYouPage = () => {
  const location = useLocation();
  const { order } = location.state || {}; // Assuming order details are passed through location.state

  if (!order) {
    return <Typography variant="h6">No order details available.</Typography>;
  }

  const { items, deliveryDate } = order;

  return (
    <Box sx={{ padding: 4 }}>
      <Paper sx={{ padding: 4, marginBottom: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Thank You for Your Order!
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          Order Summary
        </Typography>
        <List>
          {items.map((item) => (

               <React.Fragment key={item.id}>
                 <ListItem>
                   <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                     <Box
                       component="img"
                       src={item.imgSrc}
                       alt={item.title}
                       sx={{ width: 100, height: 100, objectFit: 'cover', marginRight: 2 }}
                     />
                     <Box sx={{ flexGrow: 1 }}>
                       <ListItemText
                         primary={item.title}
                         secondary={`Quantity: ${item.quantity} | Price: ₹${item.price}`}
                       />
                     </Box>
                   </Box>
                 </ListItem>
                 <Divider />
               </React.Fragment>

          ))}
        </List>
        <Typography variant="h6" component="h2" gutterBottom>
          Expected Delivery Date
        </Typography>
        <Typography variant="body1">{deliveryDate}</Typography>
      </Paper>
    </Box>
  );
};

export default ThankYouPage;
